import {useEffect} from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {Login} from 'screens';
import {useAppSelector} from 'store/hooks';

function Home() {
  return (
    <div>
      <h1>Home</h1>
    </div>
  );
}

function GuestRoutes() {
  const {isLoggedIn} = useAppSelector((state) => state.login);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login/');
    }
  }, [isLoggedIn, navigate]);
  return (
    <Routes>
      <Route path="/" Component={Home} />
      <Route path="/login/" Component={Login} />
    </Routes>
  );
}
export default GuestRoutes;
